import AndieGenericToolRender from './AndieGenericToolRender';
import { useTranslation } from 'react-i18next';
import { ActionRenderAi } from '@/ai/types/action-render-ai';
import { OpenInNewRounded } from '@mui/icons-material';
import { useEffect, useRef } from 'react';
import { ActionResponseStatusAi } from '@/ai/enum/action-response-status-ai';
import { useAndie } from '@/providers/andie-provider';
import { useLocation } from 'react-router-dom';

type ActionResponse = { postId: string; routePath: string; opened: boolean };
type ActionArgs = { postId: string };

export type AndieOpenPostToUserByIdProps = ActionRenderAi<ActionResponse, ActionArgs>;

const AndieOpenPostToUserById = (props: AndieOpenPostToUserByIdProps) => {
    const { t } = useTranslation();
    const { helpers } = useAndie();
    const executingSteps = useRef<number>(0);
    const pathname = useLocation().pathname;

    useEffect(() => {
        if (props.status === ActionResponseStatusAi.EXECUTING) {
            executingSteps.current += 1;
        }

        if (
            props.status === ActionResponseStatusAi.COMPLETE &&
            props.result?.postId &&
            executingSteps.current > 0
        ) {
            // We use this approach instead of refetch because PostDialog uses formik and can't be safely updated, 'enableReinitialize' is not an option because it causes other issues
            if (pathname.endsWith('post/' + props.result.postId)) {
                helpers.navigateBackFromPost();
                setTimeout(
                    (postId) => {
                        helpers.navigateToPost(postId);
                    },
                    500,
                    props.result.postId,
                );
            } else {
                helpers.navigateToPost(props.result.postId, true);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.status]);

    return (
        <AndieGenericToolRender<ActionResponse, ActionArgs>
            title={() => t('andie.tool.open-post-tool.title')}
            icon={<OpenInNewRounded fontSize="small" />}
            loadingMessages={() => [t('andie.tool.open-post-tool.loading')]}
            completeMessage={() => t('andie.tool.open-post-tool.complete')}
            {...props}
        />
    );
};

export default AndieOpenPostToUserById;
